import { V3Models } from "@istari/istari-client";

import { ShareableSendingConnection } from "~/secure-connections/model/secure-connection";

import { toEditAccess } from "./to-edit-access";

type ShareableSendingConnectionDto = V3Models.ShareableSendingConnectionDto;

export function toShareableSendingConnection(dto: ShareableSendingConnectionDto): ShareableSendingConnection {
  return {
    id: dto.id,
    label: dto.label,
    description: dto.description,
    editAccess: toEditAccess(dto.receivedAccessLevel),
  };
}
